<script lang="ts">
import { I3pService } from '@nuxtDatakodeUtils/services/i3p.service'
import CitiesGeojson from './citiesGeojson.vue'

export default {
    name: 'OrganizationsForm',
    components: { CitiesGeojson },
    props: {
        data: { type: Object, required: true },
        translationName: { type: String, required: true },
        validation: { type: Object, required: false, default: null },
        validationRules: { type: Object, required: false, default: () => {} },
        i3pService: { type: I3pService, required: true },
    },
    emits: ['updateData'],
}
</script>

<template>
    <FormSection title="Territoire" with-borders-color="primary">
        <CitiesGeojson
            :data="data"
            :i3p-service
            :edit="i3pService.editMode"
            :validation-rules
            :validation="validation?.data.communes"
            @update-data="$emit('updateData', { [`communes`]: $event })"
        />
    </FormSection>
</template>
